import React, {useState,useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import '../App.css';
import '../Slider.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Slider from '../components/Slider';
import axios from 'axios';


const Home = () => {

  const location = useLocation();

  const [rewards, setRewards] = useState({
    mall: [],
    home: [],
    pradita: [],
    wellground: []
  });

  useEffect(() => {
    getRewardMall()
    getRewardHome()
    getRewardWg()
    getRewardPradita()
  }, []);

  function getRewardMall(){
    axios.get(`${process.env.REACT_APP_API}v2/mall/reward`)
      .then(res => {
        const apiData = res.data.data;
        setRewards(prevRewards => ({
          ...prevRewards,
          mall: apiData
        }));
      })
      .catch(err => {
        console.error("Error fetching mall rewards:", err);
      });
  }

  function getRewardHome(){
    axios.get(`${process.env.REACT_APP_API}v2/home/reward`)
      .then(res => {
        const apiData = res.data.data;
        setRewards(prevRewards => ({
          ...prevRewards,
          home: apiData
        }));
      })
      .catch(err => {
        console.error("Error fetching mall rewards:", err);
      });
  }

  function getRewardWg(){
    axios.get(`${process.env.REACT_APP_API}v2/wgn/reward`)
      .then(res => {
        const apiData = res.data.data;
        setRewards(prevRewards => ({
          ...prevRewards,
          wellground: apiData
        }));
      })
      .catch(err => {
        console.error("Error fetching mall rewards:", err);
      });
  }

  function getRewardPradita(){
    axios.get(`${process.env.REACT_APP_API_PRADITA}integration/mall/list-reward-pradita`,
      {
        headers: {
          'APP-KEY': 'f22b73725ee16347efa5730ab7aa3d28',
        }
      })
      .then(res => {
        const apiData = res.data.data;
        setRewards(prevRewards => ({
          ...prevRewards,
          pradita: apiData
        }));
      })
      .catch(err => {
        console.error("Error fetching mall rewards:", err);
      });
  }

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  const [touchStartX, setTouchStartX] = useState(0);
const [touchEndX, setTouchEndX] = useState(0);

const handleTouchStart = (e) => {
  setTouchStartX(e.targetTouches[0].clientX);
};

const handleTouchMove = (e) => {
  setTouchEndX(e.targetTouches[0].clientX);
};

const handleTouchEnd = () => {
  if (!touchStartX || !touchEndX) return;

  const distance = touchStartX - touchEndX;
  const minSwipeDistance = 50;

  if (distance > minSwipeDistance) {
    // Geser ke kiri (Next Slide)
    setActiveIndex((prevIndex) => 
      prevIndex === currentData.length - 1 ? 0 : prevIndex + 1
    );
  }

  if (distance < -minSwipeDistance) {
    // Geser ke kanan (Prev Slide)
    setActiveIndex((prevIndex) => 
      prevIndex === 0 ? currentData.length - 1 : prevIndex - 1
    );
  }

  // Reset koordinat
  setTouchStartX(0);
  setTouchEndX(0);
};

  const slides = [
    {
      title: (
        <>
          Kumpulkan stamp,
          <br />
          tukar dengan rewards menarik!
        </>
      ),
      subtitle:
        "Dengan aplikasi Summarecon Mall, kamu bisa kumpulkan Stamps setiap kali belanja di Summarecon Mall.",
    },
    {
      title: (
        <>
          Kumpulkan stamp 2,
          <br />
          tukar dengan rewards menarik! 2
        </>
      ),
      subtitle:
        "Dengan aplikasi Summarecon Mall, kamu bisa kumpulkan Stamps setiap kali belanja di Summarecon Mall 2.",
    },
  ];

  const socials = [
    "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=800",
    "https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=800",
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=800",
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=800",
    "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=800",
    "https://images.unsplash.com/photo-1516321497487-e288fb19713f?q=80&w=800",
    "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=800",
    "https://www.summarecon.com/images/article/Thumbnail%20penghargaan%20SA.jpg",
    "https://images.unsplash.com/photo-1496171367470-9ed9a91ea931?q=80&w=800",
    "https://images.unsplash.com/photo-1516321165247-4aa89a48be28?q=80&w=800",
    "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=800",
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=800",
  ];

  const allData = {
    mall:[
      {
        phone:process.env.REACT_APP_S3+"phone_product.png",
        icon: process.env.REACT_APP_S3+"Icon.png",
        title: "Rewards & Undian",
        desc: "Nikmati berbagai hadiah menarik yang bisa Anda tukar setiap harinya"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_product_2.png",
        icon: process.env.REACT_APP_S3+"Icon+(1).png",
        title: "Mission",
        desc: "Raih kesempatan mendapatkan hadiah dari Misi Misi menarik"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_product_3.png",
        icon: process.env.REACT_APP_S3+"Icon+(2).png",
        title: "Reserve Parking",
        desc: "Tak perlu khawatir tidak mendapatkan parkir saat Mall sedang ramai"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_product_4.png",
        icon: process.env.REACT_APP_S3+"Icon+(3).png",
        title: "Family Account",
        desc: "Bersama keluarga, Anda dapat menggabungkan progress akumulasi belanja"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_product_5.png",
        icon: process.env.REACT_APP_S3+"Icon+(4).png",
        title: "Stamps",
        desc: "Kumpulkan stamps untuk ditukar menjadi berbagai rewards"
      }
    ],
    home:[
      {
        phone:process.env.REACT_APP_S3+"phone_home_1.png",
        icon: process.env.REACT_APP_S3+"Icon_home_1.png",
        title: "Request Permit & Complaint",
        desc: "Anda dapat mengajukan izin dan keluhan pada aplikasi"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_home_2.png",
        icon: process.env.REACT_APP_S3+"Icon_home_2.png",
        title: "Paying Bills",
        desc: "Nikmati fitur bayar tagihan pada aplikasi dan dapatkan Stamps setelah berhasil bayar"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_home_3.png",
        icon: process.env.REACT_APP_S3+"Icon_home_3.png",
        title: "CCTV",
        desc: "Anda dapat menikmati layanan CCTV untuk jalan jalan utama di kawasan anda"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_home_4.png",
        icon: process.env.REACT_APP_S3+"Icon_home_4.png",
        title: "Shuttle Schedule",
        desc: "Anda dapat mengecek secara berkala jadwal Shuttle Bus di kawasan anda"
      },
      {
        phone:process.env.REACT_APP_S3+"phone_home_5.png",
        icon: process.env.REACT_APP_S3+"Icon_home_5.png",
        title: "Package Info",
        desc: "Anda dapat mengakses informasi apabila ada Paket yang akan diantar ke tempat Anda"
      }
    ],
    pradita:[
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/pradita_satu.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_pr_calendar.png",
        title: "Cek Jadwal Belajarmu",
        desc: "Tidak perlu repot dan lupa, lihat jadwal kuliahmu setiap saat dengan Pradita Apps"
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/pradita_dua.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_pr_payment.png",
        title: "Lihat Tagihan & Detail Pembayaran",
        desc: "Periksa pembayaran  kuliahmu kini lebih transparan, sederhana, dan efisien"
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/pradita_tiga.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_pr_file.png",
        title: "Akses Mudah Rekap Nilai ",
        desc: "Habis ujian, kini kamu bisa langsung periksa hasil nilai kuliahmu "
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/pradita_empat.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_pr_point.png",
        title: "Cek & klaim poin SKPI",
        desc: "Anda dapat mengecek secara berkala jadwal Shuttle Bus di kawasan anda"
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/pradita_lima.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_pr_news.png",
        title: "Info Berita & Acara Terbaru",
        desc: "Dapatkan informasi terlengkap tentang berita dan acara di Pradita University "
      }
    ],
    wellground:[
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/wellground_satu.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_wg_calendar.png",
        title: "Cek Jadwal Lapangan",
        desc: "Bermain kapan saja kamu mau, tanpa perlu khawatir lapangan penuh"
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/wellground_dua.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_wg_booking.png",
        title: "Booking Fasilitas",
        desc: "Lakukan booking fasilitas Wellground dari handphonemu dimanapun dan kapanpun"
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/wellground_tiga.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_wg_comunity.png",
        title: "Cari Teman di Komuntitas",
        desc: "Berolahraga bersama temanmu dan temukan teman baru dikomunitas Wellground"
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/wellground_empat.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_wg_activity.png",
        title: "Tidak Punya Perlengkapan, Tidak Masalah",
        desc: "Sewa peralatan & perlengkapan penunjang olahraga langsung melalui aplikasi"
      },
      {
        phone:process.env.PUBLIC_URL+"/assets/img/main/wellground_lima.png",
        icon: process.env.PUBLIC_URL+"/assets/img/icon/ic_pr_news.png",
        title: "Info Berita & Acara Terbaru",
        desc: "Dapatkan informasi terlengkap tentang berita dan acara di Wellground Apps"
      }
    ]
  };  

  const [activeIndex, setActiveIndex] = useState(0);
  const [activeReward, setActiveReward] = useState(0);
  const [activeTab, setActiveTab] = useState('mall');
  const [activeTabReward, setActiveTabReward] = useState('mall');
  const currentData = allData[activeTab] || [];
  const activeItem = currentData[activeIndex] || currentData[0] || {};
  const [showAllRewards, setShowAllRewards] = useState(false);
  const currentRewards = rewards[activeTabReward] || [];
  const [heroIndex, setHeroIndex] = useState(0);

  const displayedRewards = showAllRewards ? currentRewards : currentRewards.slice(0, 3);

// Interval untuk Data Mall/Reward (CurrentData)
useEffect(() => {
  const interval = setInterval(() => {
    if (currentData.length > 0) {
      setActiveIndex((prev) => (prev + 1) % currentData.length);
    }
  }, 4000);
  return () => clearInterval(interval);
}, [currentData.length, activeTab]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    setActiveIndex(0);
  };
  const handleTabChangeReward = (tabName) => {
    setActiveTabReward(tabName);
    setActiveReward(0);
    setShowAllRewards(false);
  };

  const status = () => {
    return (
      <section className="bg-[#F8F9FA] pt-16 pb-10 md:pt-16 md:pb-10" id="stats-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <h2 className="text-2xl md:text-4xl font-semibold text-center text-[#1e293b] mb-10 md:mb-14">
            Empat Tahun Bersama Summarecon Apps
          </h2>

          {/* Pembungkus: Flex & Scroll Horizontal di HP, tapi Grid 3 Kolom di Desktop */}
          <div className="flex md:grid md:grid-cols-3 gap-4 md:gap-8 overflow-x-auto snap-x snap-mandatory pb-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            
            {/* Gambar 1 */}
            <div className="flex-none w-[85%] sm:w-[60%] md:w-auto snap-center">
              <img 
                className="w-full h-auto object-contain drop-shadow-sm transition-transform duration-300 md:hover:-translate-y-2" 
                src={process.env.PUBLIC_URL + "/assets/img/main/grafik_1.png"} 
                alt="Statistik Fitur" 
              />
            </div>
            
            {/* Gambar 2 */}
            <div className="flex-none w-[85%] sm:w-[60%] md:w-auto snap-center">
              <img 
                className="w-full h-auto object-contain drop-shadow-sm transition-transform duration-300 md:hover:-translate-y-2" 
                src={process.env.PUBLIC_URL + "/assets/img/main/grafik_3.png"} 
                alt="Statistik Pengguna" 
              />
            </div>
            
            {/* Gambar 3 */}
            <div className="flex-none w-[85%] sm:w-[60%] md:w-auto snap-center">
              <img 
                className="w-full h-auto object-contain drop-shadow-sm transition-transform duration-300 md:hover:-translate-y-2" 
                src={process.env.PUBLIC_URL + "/assets/img/main/grafik_2.png"} 
                alt="Statistik Unduhan" 
              />
            </div>

          </div>
        </div>
      </section>
    )
  }

  const product = () => {
    return (
      <section id="product-section" className="pb-16 pt-16 md:pb-40 md:pt-16 bg-[#fff]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-4xl font-bold text-[#1e293b] mb-8 md:mb-10">
            Product Kami
          </h2>
          
          {/* Tab Buttons */}
          <div className="bg-[#F1F5F9] rounded-lg flex gap-3 md:w-fit overflow-x-auto snap-x p-2 mb-12 md:mb-32 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            <button 
              className={`px-6 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap snap-center transition-all duration-300 ${activeTab === 'mall' ? 'bg-[#F36F21] text-white shadow-md' : 'bg-[#F1F5F9] text-[#475569] hover:bg-[#E2E8F0]'}`}
              onClick={() => handleTabChange('mall')}
            >
              Summarecon Mall Apps
            </button>
            <button 
              className={`px-6 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap snap-center transition-all duration-300 ${activeTab === 'home' ? 'bg-[#F36F21] text-white shadow-md' : 'bg-[#F1F5F9] text-[#475569] hover:bg-[#E2E8F0]'}`}
              onClick={() => handleTabChange('home')}
            >
              Summarecon Home Apps
            </button>
            <button 
              className={`px-6 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap snap-center transition-all duration-300 ${activeTab === 'pradita' ? 'bg-[#F36F21] text-white shadow-md' : 'bg-[#F1F5F9] text-[#475569] hover:bg-[#E2E8F0]'}`}
              onClick={() => handleTabChange('pradita')}
            >
              Pradita Apps
            </button>
            <button 
              className={`px-6 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap snap-center transition-all duration-300 ${activeTab === 'wellground' ? 'bg-[#F36F21] text-white shadow-md' : 'bg-[#F1F5F9] text-[#475569] hover:bg-[#E2E8F0]'}`}
              onClick={() => handleTabChange('wellground')}
            >
              Wellground Apps
            </button>
          </div>

          {/* Area yang bisa di-swipe */}
          <div 
            className="relative w-full mx-auto pt-0 md:pt-20"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <div className="relative md:absolute z-20 mx-auto md:mx-0 w-[220px] md:w-[260px] lg:w-[280px] -mb-[140px] md:mb-0 md:top-1/2 md:-translate-y-1/2 md:left-4 lg:left-8 drop-shadow-2xl">
              <img 
                src={activeItem.phone} 
                alt={activeItem.title}
                className="w-full h-auto block pointer-events-none" 
              />
            </div>
            
            <div className="relative z-10 bg-[#F36F21] rounded-[2rem] w-full overflow-hidden flex flex-col justify-center pt-[170px] pb-10 px-6 md:pt-12 md:pb-12 md:pl-[300px] lg:pl-[340px] md:pr-12 min-h-[340px] shadow-xl text-white">
              <div className="absolute right-0 top-0 bottom-0 w-full md:w-[60%] flex justify-end pointer-events-none opacity-40 mix-blend-overlay">
                <img 
                  src={process.env.REACT_APP_S3+"circle_product.png"}
                  alt="Decoration Background"
                  className="h-full object-cover object-right"
                />
              </div>
              
              <div className="relative z-20 text-center md:text-left">
                <div className="inline-block bg-white/20 p-3 rounded-2xl mb-4 backdrop-blur-sm">
                  <img 
                    src={activeItem.icon} 
                    alt="App Icon"
                    className="w-8 h-8 md:w-10 md:h-10 object-contain pointer-events-none"
                  />
                </div>
                <h3 className="text-xl md:text-2xl font-bold mb-3">
                  {activeItem.title}
                </h3>
                <p className="text-sm md:text-base font-normal leading-relaxed opacity-90 mb-8 max-w-md mx-auto md:mx-0">
                  {activeItem.desc}
                </p>
                
                <div className="flex justify-center md:justify-start gap-2">
                  {currentData.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveIndex(index)}
                      className={`h-2 rounded-full transition-all duration-300 ${
                        index === activeIndex ? 'w-8 bg-white' : 'w-2 bg-white/50 hover:bg-white/80'
                      }`}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  const reward = () => {
    return (
      <section id="reward-section" className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e293b] mb-10 text-left md:text-left">
            Cek Reward Yang Bisa Kamu Dapatkan
          </h2>
          {/* Tabs Reward (Gunakan w-fit dan overflow agar bisa di-scroll di mobile) */}
          <div className="w-full md:w-fit flex gap-2 bg-[#F1F5F9] p-1.5 rounded-lg mb-12 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {['mall', 'home', 'pradita', 'wellground'].map((tab) => (
              <button 
                key={tab}
                className={`px-6 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-all ${activeTabReward === tab ? 'bg-[#F36F21] text-white shadow' : 'text-[#475569] hover:bg-gray-200'}`}
                onClick={() => handleTabChangeReward(tab)}
              >
                {tab === 'mall' ? 'Summarecon Mall Apps' : tab === 'home' ? 'Summarecon Home Apps' : tab === 'pradita' ? 'Pradita Apps' : 'Wellground Apps'}
              </button>
            ))}
          </div>

          {/* GRID REWARD: Grid 3 kolom di desktop, Slide horizontal di mobile */}
          {

          displayedRewards.length == 0
              ?
              <div className="flex flex-col items-center justify-center p-8 text-center">
                <img 
                  src={process.env.PUBLIC_URL + "/assets/img/empty_reward.png"} 
                  alt="Reward Tidak Tersedia" 
                  className="w-48 h-auto object-contain mb-4" 
                />
                <p className="text-gray-500 text-base font-medium">
                  Belum ada reward yang tersedia
                </p>
              </div>
              :
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {
                  displayedRewards.map((item, index) => (
                  <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 flex flex-col" key={`${activeTab}-${index}`}>
                    
                    {/* Image */}
                    <img src={item?.reward_image} alt={item?.reward_name} className="w-full h-auto object-cover" />
                    
                    {/* Content */}
                    <div className="p-5 flex flex-col flex-grow">
                      <div className="flex items-center gap-2 mb-3">
                        <img src={item?.reward_type == 'Voucher'?process.env.REACT_APP_S3+"badge.png":process.env.REACT_APP_S3+"badge_2.png"} alt="category" className="h-6 w-auto" />
                        <span className="text-xs text-gray-500 font-medium">Berlaku Hingga • {item?.valid_until}</span>
                      </div>
                      
                      <h3 className="line-clamp-2 text-xl font-bold text-[#101828] mb-2">{item?.reward_name}</h3>
                      <p className="line-clamp-3 text-[#475467] text-sm leading-relaxed mb-4">{item?.reward_description}</p>
                    </div>
                  </div>
                  ))}
              </div>
          }

          {/* Tombol Lihat Semua */}
          {currentRewards.length > 3 && !showAllRewards && (
            <div className="flex justify-center mt-12">
              <button 
                className="bg-[#F36F21] hover:bg-[#e0621a] text-white px-8 py-3 rounded-lg font-semibold transition-all"
                onClick={() => setShowAllRewards(true)}
              >
                Lihat Semua Reward
              </button>
            </div>
          )}
        </div>
      </section>
    )
  }

  const membership = () => {
    return (
    <section className="py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      
      {/* 1. Tambahkan 'flex-col md:flex-row' di sini untuk mengatur alur mobile (ke bawah) dan desktop (ke samping) */}
      <div className="relative bg-[#F36F21] rounded-[2rem] overflow-hidden min-h-[350px] md:min-h-[400px] flex flex-col md:flex-row items-center px-8 md:px-16">
        
        {/* Sisi Kiri: Konten Teks */}
        <div className="relative z-10 w-full md:w-[60%] text-center md:text-left py-12 md:py-0">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            Register Membership!
          </h2>
          <p className="text-white/90 text-sm md:text-base leading-relaxed mb-8 max-w-sm mx-auto md:mx-0">
            Nikmati akses eksklusif ke berbagai keuntungan dan fasilitas khusus. 
            Register sekarang dan nikmati reward dari kami.
          </p>
          <a 
            href="https://play.google.com/store/apps/details?id=com.summareconmall&pcampaignid=web_share" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <button className="bg-white text-[#F36F21] px-8 py-3 rounded-xl font-bold text-base hover:bg-gray-100 transition-all shadow-lg">
              Register Sekarang
            </button>
          </a>
        </div>

        {/* 2. Sisi Kanan: Gambar Frame */}
        {/* md:absolute akan membuat gambar melayang ke kanan hanya saat di desktop */}
        {/* mt-8 md:mt-0 memberikan jarak atas saat mobile agar tidak menempel ke teks */}
        <div className="flex justify-center md:absolute md:right-0 md:bottom-0 w-[60%] md:w-[35%] lg:w-[30%] pointer-events-none mt-8 md:mt-0">
          <img 
            src={process.env.REACT_APP_S3 + "frame.png"} 
            alt="Membership Frame" 
            className="w-full h-auto"
          />
        </div>

      </div>
    </div>
  </section>
    )
  }

  const about = () => {
    return (
      <section id="about-section" className="relative w-full py-20 md:py-32 flex items-center overflow-hidden">
        <img
          src={process.env.REACT_APP_S3 + "image_about.png"}
          alt="About Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/5 md:bg-gradient-to-r md:from-black/5 md:via-black/5 md:to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-white">
          <div className="max-w-2xl text-left">
            <h2 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
              Tentang Kami
            </h2>
            <p className="text-sm md:text-base leading-relaxed opacity-95">
              PT. Summarecon Agung Tbk. (Summarecon) yang
              dikenal selama lebih dari 30 tahun sebagai
              perintis pengembangan kawasan Summarecon Kelapa
              Gading juga telah berhasil dalam mengembangkan
              kawasan lain seperti, Summarecon Serpong,
              Summarecon Bekasi, Summarecon Karawang,
              Summarecon Bandung, Summarecon Bogor hingga
              Summarecon Makassar.
            </p>
          </div>
        </div>

      </section>
    );
  };

  const terms = () => {
    return (
      <section id="syarat-ketentuan" className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[55%] lg:w-[60%]">
              <h2 className="text-3xl md:text-5xl font-bold text-[#101828] mb-4 text-left">
                Syarat dan ketentuan
              </h2>
              <p className="text-[#475467] text-sm md:text-base mb-8 md:mb-12 text-left leading-relaxed">
                Kami mengajak Anda untuk membaca syarat dan ketentuan kami dengan teliti. 
                Ini panduan penting yang akan membantu Anda memahami hak dan kewajiban Anda. 
                Silakan klik di bawah untuk membacanya
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md hover:border-gray-200 transition-all cursor-pointer flex flex-col justify-between group">
                  <img 
                    src={process.env.REACT_APP_S3 + "icon_mall.png"}
                    className="w-12 h-12 mb-6 object-contain" 
                    alt="Summarecon Mall"
                  />
                  <div className="flex justify-between items-end gap-4 mt-auto">
                    <h4 className="font-semibold text-[#101828] text-sm md:text-base leading-snug">
                      Syarat dan Ketentuan Summarecon Mall Apps
                    </h4>
                    <span className="text-[#F36F21] text-xl transform group-hover:translate-x-1 transition-transform">→</span>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md hover:border-gray-200 transition-all cursor-pointer flex flex-col justify-between group">
                  <img 
                    src={process.env.REACT_APP_S3 + "icon_home.png"}
                    className="w-12 h-12 mb-6 object-contain" 
                    alt="Summarecon Home"
                  />
                  <div className="flex justify-between items-end gap-4 mt-auto">
                    <h4 className="font-semibold text-[#101828] text-sm md:text-base leading-snug">
                      Syarat dan Ketentuan Summarecon Home Apps
                    </h4>
                    <span className="text-[#F36F21] text-xl transform group-hover:translate-x-1 transition-transform">→</span>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md hover:border-gray-200 transition-all cursor-pointer flex flex-col justify-between group">
                  <img 
                    src={process.env.PUBLIC_URL + "/assets/img/Logo-pradita.png"}
                    className="w-12 h-12 mb-6 object-contain" 
                    alt="Pradita"
                  />
                  <div className="flex justify-between items-end gap-4 mt-auto">
                    <h4 className="font-semibold text-[#101828] text-sm md:text-base leading-snug">
                      Syarat dan Ketentuan Pradita Apps
                    </h4>
                    <span className="text-[#F36F21] text-xl transform group-hover:translate-x-1 transition-transform">→</span>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md hover:border-gray-200 transition-all cursor-pointer flex flex-col justify-between group">
                  <img 
                    src={process.env.PUBLIC_URL + "/assets/img/Logo-Wellground.png"}
                    className="w-12 h-12 mb-6 object-contain" 
                    alt="Wellground"
                  />
                  <div className="flex justify-between items-end gap-4 mt-auto">
                    <h4 className="font-semibold text-[#101828] text-sm md:text-base leading-snug">
                      Syarat dan Ketentuan Wellground Apps
                    </h4>
                    <span className="text-[#F36F21] text-xl transform group-hover:translate-x-1 transition-transform">→</span>
                  </div>
                </div>

              </div>
            </div>
            <div className="w-full md:w-[45%] lg:w-[40%] flex justify-center items-center mt-8 md:mt-0 relative">
              <div className="absolute bg-[#F36F21] w-[260px] h-[260px] md:w-[320px] md:h-[320px] lg:w-[400px] lg:h-[400px] rounded-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></div>
              <img
                src={process.env.REACT_APP_S3 + "tnc.png"}
                alt="Syarat dan Ketentuan"
                className="relative z-10 w-[85%] md:w-full max-w-[400px] object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

  const sosmed = () => {
    return (
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          
          {/* Judul */}
          <h2 className="text-2xl md:text-4xl font-bold text-[#101828] mb-8 md:mb-12">
            Follow Sosial Media Kami
          </h2>

          {/* Grid Gambar (2 Kolom HP, 4 Kolom Desktop) */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-10">
            {socials.map((item, index) => (
              <div 
                className="aspect-square overflow-hidden rounded-md shadow-sm" 
                key={index}
              >
                <img 
                  src={item} 
                  alt="Social Media Post" 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300 cursor-pointer" 
                />
              </div>
            ))}
          </div>

          {/* Tombol Follow */}
          <div className="flex justify-center w-full">
            <a 
              href="https://www.instagram.com/summareconapps/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <button className="bg-[#F36F21] hover:bg-[#e0621a] text-white px-8 py-3 rounded-full font-bold text-sm md:text-base transition-colors shadow-md">
                Follow @summareconapps
              </button>
            </a>
          </div>

        </div>
      </section>
    )
  }

  

  
  return (
    <div className="app-container">
      <Navbar />     
      {/* {hero()} */}
      <Slider />
      {status()}
      {product()}
      {reward()}
      {/* {membership()} */}
      {about()}
      {/* {terms()} */}
      {/* {sosmed()} */}
      <Footer />
    </div>
  );
};

export default Home;